<template>
    <div class="incomeAll">
        <h6>绑定VIP卡(已绑定)</h6>

         <div class="flex zhong bang_div"><i></i>我的绑定记录</div>
        <section class="system">
            <article class="table">
                <hgroup class="flex">
                    <p>VIP类型</p>
                    <p>卡号</p>
                    <p>绑定时间</p>
                </hgroup>
                <ul>
                    <li class="flex" v-for="(item, index) in list" :key="index">
                        <p>{{ item.Name }}</p>
                        <p>5646454</p>
                        <p>{{ item.Date }}</p>
                    </li>
                </ul>
            </article>
            <div class="flex xend pageDiv">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="model.page"
                    :page-size="model.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalCount"
                ></el-pagination>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            model: {
                page: 1,
                pageSize: 10
            },
            totalCount: 0,
            list: []
        };
    },
    methods: {
    }
};
</script>

<style scoped>

.bang_div i{
    width: 3px;
    height: 18px;
    border-radius: 50px;
    background-color: #005371;
    display: inline-block;
    margin-right: 12px;
}

.bang_div {
    font-size: 16px;
    color: #000;
    padding-top: 30px;
    padding-left: 20px;
}

.pageDiv {
    overflow: hidden;
    margin-top: 20px;
}

.table li p {
    font-size: 14px;
    width: 33.33%;
    line-height: 60px;
    text-align: center;
}

.table li p {
    border-right: solid 1px #e6e6e6;
}

.table li {
    border-bottom: solid 1px #e6e6e6;
}

.table li:last-child {
    border-bottom: none;
}

.table li p:last-child {
    border-right: none;
}

.table ul {
    overflow: hidden;
}

.table hgroup p {
    font-size: 14px;
    background-color: #eaeaea;
    width: 33.33%;
    line-height: 60px;
    text-align: center;
}

.table {
    overflow: hidden;
    border: solid 1px #e6e6e6;
    box-sizing: border-box;
}

.system {
    overflow: hidden;
    padding: 20px;
}

/* safety */

.incomeAll > h6 {
    border-bottom: solid 1px #e6e6e6;
    font-size: 16px;
    color: #333;
    height: 62px;
    line-height: 62px;
    text-indent: 20px;
    position: relative;
}

.incomeAll > h6::after {
    content: '';
    width: 68px;
    height: 2px;
    background-color: #333;
    position: absolute;
    left: 20px;
    bottom: 0;
    z-index: 0;
}

.no-pdf {
    display: flex;
    justify-content: space-around;
    padding: 0 40px;
}
</style>
